import { Popover } from "@mui/material";
import React, { useState, useContext, useRef } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { makeStyles } from "@mui/styles";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { SettlementReqStatus } from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import Checkbox from "../../../Components/Checkbox/Checkbox";
import "../ApprovalModal/ApprovalModal.css";
import { getContext } from "../../../Helpers/Context/Context";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { UpdateApprovalSettlementRequest, documentDetails } from "../../../Helpers/APIEndPoints/EndPoints";

const useGapStyles = makeStyles({
  paper: {
    marginTop: "-1rem",
  },
});

const FinalsettlementModal = ({
  open,
  anchorEl,
  handleClose,
  module,
  Id,
  ReqMemberId
}) => {
  const [hideShowComment, setHideShowComment] = useState(true);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [comment, setComment] = useState("");
  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);
  const [error, setError] = React.useState<any>({});
  const navigate = useNavigate();
  const context = getContext();
  let UserName = context.FirstName + " " + context.MiddleName;
  let MemberId = context.MemberId;
  const [errorRemark, setErrorRemark] = useState("");
  const [reviewerRemark, setReviewerRemark] = useState("");
  const [fileName, setFileName] = useState("");
  const [binaryData, setBinaryData] = useState(null);
  const [fileData, setFileData] = useState(null);

  const { state } = useLocation();
  const currentStatus =
    state !== null && state.currentStatus ? state.currentStatus : 0;
  const RequestId = state !== null && state.RequestId ? state.RequestId : 0;
  const classes = useGapStyles();
  const inputFileRef = useRef(null);
  // const Id = state ? state.Id : null;
  let documentId = null;
  const handleBtnClick = (e) => {
    if (inputFileRef && inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  const onChangeUploadFile = async (value) => {
    if (value.target.files.length > 0) {
      let errormessage = "FileError";

      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["pdf"];
      let validfile = e.split(".").pop();
      setFileName(e);
      if (!extension.includes(validfile)) {
        setError({
          ...error,
          [errormessage]: "File should be only pdf",
        });
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        setError({
          ...error,
          [errormessage]: "Please select file size upto 2mb",
        });
        value = file.name;
      } else {
        setError({
          ...error,
          [errormessage]: "",
        });
        
        let tempString = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }
        setBinaryData(fileBase64);
        value = fileBase64;
      }
    }
    setFileData(value);
  };

  const isFile = (input: any) => "File" in window && input instanceof File;

  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  const onChange = (event, value) => {
    if (event === "comment") {
      setComment(value.target.value);
      setErrorRemark("");
    } else if (event === "approve") {
      setApprove(value);
      setReject(!value);
      setHideShowComment(true);
      setComment("");
    } else if (event === "reject") {
      setReject(value);
      setApprove(!value);
      setHideShowComment(false);
    } else if (event === "reviewerRemark") {
      setReviewerRemark(value);
      setHideShowComment(false);
    }
  };

  const onSubmit = async () => {
    let errorObj = {};
    setErrorRemark("");
    showLoader();

    if (approve === false && reject === false) {
      notify(1, "Select at least one checkbox.");

      errorObj = { approve: "Select at least one checkbox." };
    }
    if (approve === true) {
      if (!fileData) {
        errorObj = {
          ...errorObj,
          ["FileError"]: "This field is required",
        };
      }
    }

    if (approve === false) {
      if (!comment) {
        setErrorRemark("Remark is required");
        errorObj = {
          ...errorObj,
          [comment]: "This field is required",
        };
      }
    }

    setError(errorObj);

    if (Object.keys(errorObj).length === 0) {
      if (binaryData) {
        // for (const key in fileData) {
          let param = {
            DocumentName: fileName,
            DocumentType: fileName.split(".").pop(),
            DocumentUrl: "",
            BinaryFile: binaryData,
          };
        
          const insertData = await APICall(documentDetails, param);
          if (insertData.Status === ApiStatus.OK && insertData?.Data) {
            documentId = insertData.Data;
          } else {
            notify(
              ToastType.Error,
              insertData?.Message ||
                "Failed to upload document, Please try again later."
            );
            return;
          }
        // }
        if (!documentId && documentId != 0) {
          notify(
            ToastType.Error,
            "Failed to upload document, Please try again later."
          );
          return;
        }
      }

      let statusId = 0;

      let requestParams = {
        MemberId: ReqMemberId,
        Id: Id,
        RoleId: context.CurrentRoleId, 
        StatusId: statusId,
        Comment: comment,
        Approver: context?.Id,
        CreatedBy: context?.Id,
        ModifiedBy: context?.Id,
        DocumentDetailId: documentId,
        IsActive: true
      };
      

      if (approve) {
        //statusId = SettlementReqStatus.FinalSettlementApprovalPending;
         statusId = SettlementReqStatus.Settlement_Approved;
      } else if (reject) {
        statusId = SettlementReqStatus.Settlement_Rejected;
      }

      requestParams.StatusId = statusId;

      const res = await APICall(UpdateApprovalSettlementRequest, requestParams);

      if (res.Status === ApiStatus.OK) {
        
        if (res.Message.toLocaleLowerCase() === "Ok".toLocaleLowerCase()) {
          let mesaage = "";

          if (approve === true) {
            mesaage = "approved";
          }

          if (reject === true) {
            mesaage = "rejected";
          }

          notify(ToastType.Success, `Request ${mesaage} Successfully.`);
          handleClose();
          navigate("/SettlementRequestDashboard");
        }
      } else {
        notify(
          ToastType.Error,
          "Final Settlement approval request submittion failed. Please Contact Administrator"
        );
      }
    }
    hideLoader();
  };

  return (
    <Popover
      id={"id"}
      open={open}
      anchorEl={anchorEl}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      classes={{
        paper: classes.paper,
      }}
      className=""
    >
      <div className="p-3 verify-modal">
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox
                id="approve"
                title="Approve"
                onChange={onChange}
                checked={approve}
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <Checkbox
                id="reject"
                title="Reject"
                onChange={onChange}
                checked={reject}
              />
            </div>
          </div>
          <br />
          {approve && (
            <div className="form-group">
              <label>Upload Document <sup>*</sup></label>
              <input
                className="form-control inputfile inputfile-6"
                name={`row_0`}
                id={`row_0`}
                type="file"
                ref={inputFileRef}
                onChange={(event) => {
                  onChangeUploadFile(event);
                }}
                multiple={false}
              />

              <label
                htmlFor="file-8-uploadPan"
                className="form-control"
                style={{ border: "none" }}
                onClick={handleBtnClick}
              >
                <span style={{ float: "right", width: "60%" }}>{fileName}</span>
                <strong
                  style={{
                    width: "35%",
                    left: "0",
                    borderTopRightRadius: "0",
                    borderBottomRightRadius: "0",
                  }}
                >
                  <i className="far fa-file"></i> Browse
                </strong>{" "}
              </label>
              {error["FileError"] && (
                <p className="text-danger">{error["FileError"]}</p>
              )}
            </div>
          )}
          <br />
          {!hideShowComment && (
            <div className="row pb-3">
              <div className="col-lg-12 col-sm-12 col-xs-12 ">
                <div className="form-group">
                  <label>Reviewer Name</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    value={UserName}
                  />
                </div>
                <div className="form-group">
                  <label>Reviewer Remark</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    value={comment}
                    onChange={(val: any) => onChange("comment", val)}
                    textArea={true}
                  />
                  {errorRemark && <p className="text-danger">{errorRemark}</p>}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <ButtonComponent
            icon={""}
            className="btn btn-cancel"
            style={{ marginLeft: 5 }}
            onClick={handleClose}
            value={"Cancel"}
            id={"cancelBtn"}
          />
          <ButtonComponent
            icon={""}
            value={"Submit"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={onSubmit}
          />
        </div>
      </div>
    </Popover>
  );
};

export default FinalsettlementModal;
